/*
 * @Author: Src
 * @Date: 2025-05-09 15:01:39
 * @LastEditTime: 2025-05-28 19:00:20
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/invoiceRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import Invoice from '@/views/invoice/index.vue';
import InvoiceIng from '@/views/invoice/invoiceIng.vue';
import InvoiceManagement from '@/views/invoice/invoiceManagement.vue';
import { AuthEnum } from '@/services/permission.service';

const invoiceRoutes: RouteConfig = {
  path: '/invoice',
  component: Main,
  redirect: {
    name: 'invoice.index',
  },
  meta: {
    title: '发票管理',
  },
  children: [
    {
      path: 'index',
      component: Invoice,
      name: 'invoice.index',
      props: {
        auth: [AuthEnum.发票管理],
      },
      meta: {
        title: '发票管理',
      },
    },
    {
      path: 'invoiceIng',
      component: InvoiceIng,
      name: 'invoice.invoiceIng',
      props: {
        auth: [AuthEnum.申请开票],
      },
      meta: {
        title: '申请开票',
      },
    },
    {
      path: 'management',
      component: InvoiceManagement,
      name: 'invoice.management',
      props: {
        auth: [AuthEnum.发票查看],
      },
      meta: {
        title: '发票管理',
      },
    },
  ],
};

export default invoiceRoutes;
